/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UsageFeeStatus
 */
export interface UsageFeeStatus {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeStatus
     */
    'status': UsageFeeStatusStatusEnum;
}

export const UsageFeeStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferReceivable: 'TRANSFER_RECEIVABLE'
} as const;

export type UsageFeeStatusStatusEnum = typeof UsageFeeStatusStatusEnum[keyof typeof UsageFeeStatusStatusEnum];


